import types from '../mutation-types';
import TopicsAPI from '../../api/topics';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getTopics(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getTopics({ commit }) {
    commit(types.SET_TOPIC_UI_FLAG, { isFetching: true });
    try {
      const response = await TopicsAPI.get();
      commit(types.SET_TOPICS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_TOPIC_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createTopic({ commit }, { name }) {
    commit(types.SET_TOPIC_UI_FLAG, { isCreating: true });
    try {
      const response = await TopicsAPI.create({ topic: { name } });
      commit(types.ADD_TOPIC, response.data);
      return response.data;
    } finally {
      commit(types.SET_TOPIC_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_TOPIC_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_TOPICS](_state, data) {
    _state.records = data;
  },
  [types.ADD_TOPIC](_state, data) {
    const exists = _state.records.some(record => record.id === data.id);
    if (!exists) {
      _state.records = [..._state.records, data].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
